import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VoicemailIcon(props: IconProps) {
    return <Icon {...props} iconKey={"voicemail"}/>
}
